import { FormItem } from "@freightsimple/ui-core/FormLayout/FormItem";
import { PhoneInput } from "@freightsimple/ui-core/Controls/PhoneInput";
import { ShowFormErrors } from "@freightsimple/ui-core/FormLayout/ShowFormErrors";
import { Stack } from "@freightsimple/ui-core/ComponentLayout/Stack";
import { TextInput } from "@freightsimple/ui-core/Controls/TextInput";
import type { ContactErrors } from "../Validators/contactsErrorMessagesForContact";
import type { Contact } from "@freightsimple/generated-dashboard-openapi-client/models/Contact";
import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import ContactQuestionBubble from "../Bubbles/ContactQuestionBubble";

interface ContactInputProps {
  contactChanged: (_: Partial<Contact>) => void;
  contact: Partial<Contact>;
  errorMessages: ContactErrors | undefined;
  forceValidation: boolean;
  /** Character caps for the text fields — see the same prop on
   *  LocationsAddressInput. */
  maxLengths?: { contactName: number; emailAddress: number } | undefined;
}

const ContactsLargeContactInput: React.FC<ContactInputProps> = (
  props: ContactInputProps,
) => {
  return (
    <ShowFormErrors show={props.forceValidation}>
      {/* No width of its own: the fields fill whatever the caller gives them —
          a dialog body or a wizard page — same as the sibling ContactsInput. */}
      <Stack gap={2} align="stretch">
        {/* The bubble hangs off the first field rather than a section header:
            every caller is a one-section dialog or wizard page, so the header
            it used to sit on was labelling nothing. */}
        <FormItem
          label={
            <>
              Contact Name
              <ContactQuestionBubble context={LocationContext.Any} />
            </>
          }
          error={props.errorMessages?.contactName}
          fillWidth
        >
          <TextInput
            type="text"
            name="contact_contact_name"
            value={props.contact?.contactName || ""}
            onChange={(e) =>
              props.contactChanged({
                contactName: e.target.value,
              })
            }
            width="full"
            maxLength={props.maxLengths?.contactName}
          />
        </FormItem>
        <FormItem error={props.errorMessages?.phoneNumber} fillWidth>
          <PhoneInput
            phoneNumber={props.contact.phoneNumber}
            extension={props.contact.phoneNumberExtension}
            onPhoneNumberChange={(value: string) => {
              props.contactChanged({ phoneNumber: value });
            }}
            onExtensionChange={(value: string) => {
              props.contactChanged({
                phoneNumberExtension: value,
              });
            }}
            width="full"
          />
        </FormItem>
        <FormItem
          label="Email Address"
          error={props.errorMessages?.emailAddress}
          fillWidth
        >
          <TextInput
            type="email"
            name="contact_email_address"
            value={props.contact?.emailAddress || ""}
            onChange={(e) =>
              props.contactChanged({
                emailAddress: e.target.value,
              })
            }
            width="full"
            maxLength={props.maxLengths?.emailAddress}
          />
        </FormItem>
      </Stack>
    </ShowFormErrors>
  );
};
export default ContactsLargeContactInput;
